export const SERIES_DATA = [
  {
    id: 1,
    title: "Mindset & Start",
    subtitle: "Základy podnikání a hodnoty beplan",
    videos: [
      { id: 1, title: "Vítejte v beplan University", duration: "12:30", description: "Úvodní video do vzdělávacího systému beplan University. Seznámíte se s platformou a její strukturou." },
      { id: 2, title: "Proč beplan — hodnoty a smysl", duration: "15:20", description: "Jaké hodnoty stojí za beplan a proč to děláme. Poslání a vize společnosti." },
      { id: 3, title: "Co je podnikání vs zaměstnání", duration: "18:45", description: "Rozdíl v myšlení podnikatele a zaměstnance. Výhody a nevýhody obou cest." },
      { id: 4, title: "Jak vypadá váš den v beplan", duration: "10:15", description: "Typický den finančního poradce v beplan. Praxe a rutina." },
      { id: 5, title: "Kariéra a projekty v beplan", duration: "14:30", description: "Kariérní cesta a možnosti růstu v rámci beplan." },
      { id: 6, title: "Jak funguje odměňování", duration: "16:00", description: "Systém odměňování, provize a bonusy ve finančním poradenství." },
    ]
  },
  {
    id: 2,
    title: "Finanční plán & Systém",
    subtitle: "Základy finančního plánování a CRM",
    videos: [
      { id: 7, title: "Co je finanční plán a proč ho každý potřebuje", duration: "20:10", description: "Proč je finanční plán základem každého poradenství." },
      { id: 8, title: "7 oblastí finančního plánu", duration: "22:30", description: "Kompletní přehled 7 klíčových oblastí finančního plánu." },
      { id: 9, title: "Jak vypadá reálné portfolio klienta", duration: "18:00", description: "Praktické příklady portfolií reálných klientů." },
      { id: 10, title: "CRM a systém práce", duration: "15:45", description: "Jak efektivně používat CRM systém pro správu klientů." },
      { id: 11, title: "Compliance a etika", duration: "14:20", description: "Etický kodex a regulatorní požadavky pro finanční poradce." },
    ]
  },
  {
    id: 3,
    title: "Obchodní proces & Dovednosti",
    subtitle: "Od prvního telefonu po uzavření smlouvy",
    videos: [
      { id: 12, title: "Proč finanční poradenství — hodnota pro klienta", duration: "16:30", description: "Jak prezentovat hodnotu finančního poradenství klientům." },
      { id: 13, title: "První schůzka A1", duration: "25:00", description: "Struktura a průběh první schůzky s klientem." },
      { id: 14, title: "Finanční analýza A2", duration: "22:15", description: "Jak provést komplexní finanční analýzu klienta." },
      { id: 15, title: "Prezentace plánu P1 a podpis", duration: "20:40", description: "Jak prezentovat finanční plán a uzavřít smlouvu." },
      { id: 16, title: "Kde hledat klienty", duration: "18:30", description: "Strategie a kanály pro získávání nových klientů." },
      { id: 17, title: "Projekt 100", duration: "12:00", description: "Metodika Projekt 100 pro budování klientské základny." },
      { id: 18, title: "LinkedIn a Instagram", duration: "15:20", description: "Využití sociálních sítí pro získávání klientů." },
      { id: 19, title: "První telefon — skript", duration: "14:45", description: "Ověřený skript pro první telefonát s potenciálním klientem." },
      { id: 20, title: "Strach z odmítnutí", duration: "11:30", description: "Jak překonat strach z odmítnutí a budovat odolnost." },
      { id: 21, title: "Struktura hovoru a námitky", duration: "19:00", description: "Jak strukturovat telefonní hovor a reagovat na námitky." },
      { id: 22, title: "Jak žádat o doporučení", duration: "13:15", description: "Techniky pro získávání doporučení od spokojených klientů." },
      { id: 23, title: "Zkoušky ČNB", duration: "16:40", description: "Příprava na zkoušky České národní banky." },
    ]
  },
  {
    id: 4,
    title: "Produkty",
    subtitle: "Přehled finančních produktů",
    videos: [
      { id: 24, title: "Životní pojištění", duration: "20:00", description: "Kompletní průvodce životním pojištěním — typy, výhody, nastavení." },
      { id: 25, title: "Neživotní pojištění", duration: "18:30", description: "Majetkové pojištění, pojištění odpovědnosti a další." },
      { id: 26, title: "Hypotéky a úvěry", duration: "22:45", description: "Jak funguje hypoteční trh a jaká jsou pravidla." },
      { id: 27, title: "Stavební spoření", duration: "15:10", description: "Stavební spoření - statni prispevky a vyhody." },
      { id: 28, title: "Investice", duration: "25:30", description: "Základy investování — fondy, akcie, dluhopisy." },
      { id: 29, title: "Penzijní spoření", duration: "17:20", description: "III. pilíř penzijního systému a státní příspěvky." },
      { id: 30, title: "Bankovní služby", duration: "14:00", description: "Přehled bankovních produktů a služeb." },
    ]
  },
  {
    id: 5,
    title: "Případové studie",
    subtitle: "Reálné příklady z praxe",
    videos: [
      { id: 31, title: "Případ 1 — Mladý single", duration: "20:15", description: "Finanční plán pro mladého člověka bez závazků." },
      { id: 32, title: "Případ 2 — Rodina s hypotékou", duration: "24:30", description: "Komplexní řešení pro rodinu s hypotékou a dětmi." },
      { id: 33, title: "Případ 3 — Klient s existujícími smlouvami", duration: "22:00", description: "Jak revidovat a optimalizovat stávající smlouvy." },
      { id: 34, title: "Případ 4 — Senior před důchodem", duration: "19:45", description: "Finanční plánování pro klienty blízko důchodu." },
      { id: 35, title: "Nejčastější chyby nováčků", duration: "16:30", description: "Jak se vyhnout nejčastějším chybám začátečníků." },
    ]
  },
  {
    id: 6,
    title: "Pokročilé",
    subtitle: "Expertní témata a vedení týmu",
    videos: [
      { id: 36, title: "Pokročilé nastaveni zivotniho pojisteni", duration: "23:00", description: "Detailní nastavení produktů životního pojištění." },
      { id: 37, title: "Investiční portfolio — sestavení a správa", duration: "26:15", description: "Jak sestavit a spravovat investiční portfolio." },
      { id: 38, title: "Refinancování hypotéky — celý proces", duration: "21:30", description: "Kompletní průvodce refinancováním hypotéky." },
      { id: 39, title: "Daňová optimalizace", duration: "18:45", description: "Legální způsoby optimalizace daňové zátěže." },
      { id: 40, title: "Jak vést a školit vlastní tým", duration: "20:00", description: "Leadership a management v rámci finančního poradenství." },
    ]
  }
];
